import React, { useState, useEffect } from 'react'
import LoginForm from './LoginForm'
import Container from '@mui/material/Container'
import useMediaQuery from '@mui/material/useMediaQuery'
import useClasses from '../../components/hooks/UseClasses'
import { useAuth } from '@/components/app-context/AuthContext'

const styles = () => ({
  back: {
    backgroundPosition: 'absolute',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    maxWidth: '400px',
  },
})

const Login = ({ standard = true }) => {
  const [errors, setErrors] = useState(null)
  const classes = useClasses(styles)
  const { login } = useAuth()
  const isDesktop = useMediaQuery('(min-width:1024px)')
  const isTablet = useMediaQuery('(min-width:768px)')

  const device = isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile'

  const handleSigIn = async (values) => {
    await login(values.user, values.password).catch((e) => {
      setErrors(e)
    })
  }

  useEffect(() => {
    return () => {
      setErrors(null)
    }
  }, [])

  const getBackgroundImage = ({ device, standard }) => {
    if (standard) {
      switch (device) {
        case 'desktop':
          return '/assets/DESKTOP.webp'
        case 'tablet':
          return '/assets/TABLET.webp'
        case 'mobile':
          return '/assets/MOBILE.webp'
      }
      // Caso de que standard === false, es decir, para massol (por ahora son exactamente las mismas imágenes)
    } else {
      switch (device) {
        case 'desktop':
          return '/assets/DESKTOP.webp'
        case 'tablet':
          return '/assets/TABLET.webp'
        case 'mobile':
          return '/assets/MOBILE.webp'
      }
    }
  }

  return (
    <div
      className={classes.back}
      style={{
        backgroundImage: `url(${getBackgroundImage({ device, standard })})`,
      }}>
      <Container component="main" maxWidth="xs" className={classes.container}>
        <LoginForm onSigin={handleSigIn} errors={errors} standard={standard} />
      </Container>
    </div>
  )
}

export default Login
